type Props = {
  layout?: 'horizontal' | 'vertical'
}

type Options = { props?: Props; index?: number }

/**
 * PrimeVue passthrough for Splitter / SplitterPanel.
 * Export object keys that PrimeVue will look for: `splitterpanel`.
 * Keeps classes literal so Tailwind JIT picks them up.
 */
export default {
  root: ({ props }: Options) => ({
    // layout: horizontal -> row, vertical -> column
    class: [
      'bg-white dark:bg-[var(--card)]',
      props?.layout === 'vertical' ? 'flex flex-col w-full h-full' : 'flex w-full h-full',
      'items-stretch'
    ]
  }),
  // individual panel wrapper (the actual child panel element)
  // @ts-ignore
  panel: ({ props }: Options) => ({
    class: [
      'flex-1',
      'overflow-auto',     // allow panel content to scroll
      'p-4',
      'rounded-md',
      'bg-background dark:bg-background',
      'text-slate-900 dark:text-white',
      'border-primary'
    ]
  }),

  // content area inside the panel (if you need separate target)
  content: {
    class: [
      'w-full',
      'h-full',
      'flex flex-col'
    ]
  },

  // gutter (if you want to style the resize gutter between panels)
  gutter: ({ props }: Options) => ({
    class: [
      props?.layout === 'vertical' ? 'cursor-row-resize' : 'cursor-col-resize',
      'flex items-center justify-center',
      'bg-transparent hover:bg-slate-100 dark:hover:bg-slate-700',
      'select-none'
    ]
  })
}
